// JavaScript Document
/* Item List */
function mapli(callback,append,directory="",loop){
var list = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + directory + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
        jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;

        var display_num = "";
        if(loop) {
            var display_num = loop;
        } else {
            var display_num = len;
        }
    		for(var i=0; i < display_num; i++){
				if(json[i].name != ""){
					list = '<li class="' + json[i].class + '"><a href="' + json[i].url_o + '" target="_top"><div class="imgArea"><img src="' + json[i].img + '" alt="' + json[i].name + '"></div><div class="txtArea"><div class="catemark">' + json[i].cat + '</div><p class="name">' + json[i].name + '</p></div></a></li>';
				} else {
					list = '<li><p class="name">残念ながらお取り扱いがございません。</p></li>';
				}
   				$(append).append(list);
   			}
		}
    })
};